import { motion } from "framer-motion";
import { Mail, MapPin, Anchor } from "lucide-react";
import { CONTATTI } from "@/lib/site";

const ITEMS = [
  {
    icon: Mail,
    label: "Email",
    value: CONTATTI.email,
    href: `mailto:${CONTATTI.email}`,
    testId: "contatto-email",
  },
  {
    icon: MapPin,
    label: "Studio",
    value: CONTATTI.indirizzo,
    href: "https://www.google.com/maps/search/?api=1&query=Via+Generale+Guisan+8B+6900+Lugano+Paradiso",
    testId: "contatto-indirizzo",
  },
];

const Contatti = () => (
  <footer id="contatti" className="relative bg-[#0C1B33] pb-10 pt-20 text-[#FAF8F5] sm:pt-24" data-testid="contatti-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12 max-w-2xl"
      >
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.22em] text-[#14B8A6]">06 — Contatti</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight sm:text-5xl">
          Il faro resta acceso
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[#FAF8F5]/70">
          Domande sul percorso, sui costi o sulle date? Scrivici o chiamaci: ti rispondiamo volentieri.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {ITEMS.map((item, idx) => {
          const Icon = item.icon;
          return (
            <motion.a
              key={item.label}
              data-testid={item.testId}
              href={item.href}
              target={item.href.startsWith("http") ? "_blank" : undefined}
              rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: idx * 0.08 }}
              whileHover={{ y: -4 }}
              className="group rounded-2xl border border-[#FAF8F5]/12 bg-[#FAF8F5]/[0.04] p-6 transition-[background-color,border-color] duration-300 hover:border-[#14B8A6]/50 hover:bg-[#FAF8F5]/[0.08]"
            >
              <Icon className="mb-4 h-6 w-6 text-[#14B8A6] transition-transform duration-300 group-hover:scale-110" />
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#FAF8F5]/50">{item.label}</p>
              <p className="mt-1.5 break-words text-sm font-medium text-[#FAF8F5]">{item.value}</p>
            </motion.a>
          );
        })}
      </div>

      <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-[#FAF8F5]/10 pt-8 text-xs text-[#FAF8F5]/45 sm:flex-row">
        <p className="flex items-center gap-2">
          <Anchor className="h-4 w-4 text-[#14B8A6]" />
          <span className="font-display text-base italic text-[#FAF8F5]/70">Arcipelago</span>
          — psicoeducazione e auto-aiuto per adulti con ADHD
        </p>
        <div className="flex items-center gap-5">
          <p data-testid="footer-credit">© 2026 Arcipelago · Lugano Paradiso</p>
          <a href="/admin" data-testid="footer-area-riservata" className="transition-colors hover:text-[#14B8A6]">
            Area riservata
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Contatti;
